export const validateMobilePhone = (value: string) => {
  return value.replace(/[^ 0-9+()]/g, '');
};

export const addSpacesForNumber = (num: number) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
